import { DialogComponent } from '@theme/dialog';
import { CartAddEvent, ThemeEvents } from '@theme/events';

class CartDrawerComponent extends DialogComponent {
  connectedCallback() {
    super.connectedCallback();
    document.addEventListener(CartAddEvent.eventName, this.#handleCartAdd);
    document.addEventListener(ThemeEvents.cartUpdate, this.#handleCartUpdate);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    document.removeEventListener(CartAddEvent.eventName, this.#handleCartAdd);
    document.removeEventListener(ThemeEvents.cartUpdate, this.#handleCartUpdate);
  }

  #handleCartAdd = () => {
    if (this.hasAttribute('auto-open')) {
      this.showDialog();
    }
  };

  #handleCartUpdate = () => {
    // Reinitialize slider when cart items are updated
    if (this.refs?.dialog?.open) {
      this.#destroyRecommendationsSlider();
      // Use setTimeout to ensure DOM is updated after cart update
      setTimeout(() => {
        this.#initRecommendationsSlider();
      }, 100);
    }
  };

  open() {
    this.showDialog();

    /* Init slider when drawer opens */
    this.#initRecommendationsSlider();

    customElements.whenDefined('shopify-payment-terms').then(() => {
      const installmentsContent =
        document.querySelector('shopify-payment-terms')?.shadowRoot;
      const cta = installmentsContent?.querySelector('#shopify-installments-cta');
      cta?.addEventListener('click', this.closeDialog, { once: true });
    });
  }

  close() {
    /* Destroy slider before closing drawer */
    this.#destroyRecommendationsSlider();

    this.closeDialog();
  }

  /* -------------------------------
   * Swiper Init
   * ------------------------------- */
  #initRecommendationsSlider() {
    if (typeof Swiper === 'undefined') return;

    const carousels = this.querySelectorAll(
      '.cart-drawer-recommendations__carousel'
    );

    carousels.forEach((carousel) => {
      if (carousel.classList.contains('swiper-initialized')) return;

      const swiperInstance = new Swiper(carousel, {
        slidesPerView: 1,
        spaceBetween: 30,

        /*
         pagination: {
          el: carousel.querySelector('.swiper-pagination'),
          clickable: true,
        },
        */
        navigation: {
          nextEl: carousel.querySelector('.swiper-button-next'),
          prevEl: carousel.querySelector('.swiper-button-prev'),
        },
        scrollbar: {
          el: carousel.querySelector('.swiper-scrollbar'),
          draggable: true,
        },
      });

      /* Store instance reference on DOM */
      carousel._swiperInstance = swiperInstance;
    });
  }

  /* -------------------------------
   * Swiper Destroy
   * ------------------------------- */
  #destroyRecommendationsSlider() {
    const carousels = this.querySelectorAll(
      '.cart-drawer-recommendations__carousel'
    );

    carousels.forEach((carousel) => {
      const swiper = carousel._swiperInstance;

      if (!swiper) return;

      swiper.destroy(true, true);
      carousel._swiperInstance = null;
    });
  }
}

if (!customElements.get('cart-drawer-component')) {
  customElements.define('cart-drawer-component', CartDrawerComponent);
}
